<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav" fixedInViewport
                 [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
                 [mode]="(isHandset$ | async) ? 'over' : 'side'"
                 [opened]="(isHandset$ | async) === false" >
      <!-- On mobile the drawer is an overlay; close it once a nav item is tapped. -->
      <app-side-menu class="side-menu"
                     (click)="drawer.mode === 'over' && drawer.close()"></app-side-menu>
    </mat-sidenav>
    <mat-sidenav-content>
      <app-top-bar [showMenuButton]="(isHandset$ | async) === false"
                   (toggleDrawer)="drawer.toggle()"></app-top-bar>
      <main class="main-content" [class.has-bottom-nav]="isHandset$ | async">
        <router-outlet></router-outlet>
      </main>
      @if (isHandset$ | async) {
        <app-bottom-nav></app-bottom-nav>
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
